var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.94141 4.99905C6.94114 5.52948 6.73017 6.03808 6.35491 6.41297C5.97965 6.78785 5.47084 6.99831 4.94041 6.99805C4.40997 6.99778 3.90137 6.78681 3.52649 6.41155C3.1516 6.03629 2.94114 5.52748 2.94141 4.99705C2.94167 4.46661 3.15264 3.95801 3.5279 3.58313C3.90316 3.20824 4.41197 2.99778 4.94241 2.99805C5.47284 2.99831 5.98144 3.20928 6.35633 3.58454C6.73121 3.9598 6.94167 4.46861 6.94141 4.99905ZM7.00141 8.47905H3.00141V20.999H7.00141V8.47905ZM13.3214 8.47905H9.34141V20.999H13.2814V14.429C13.2814 10.769 18.0514 10.429 18.0514 14.429V20.999H22.0014V13.069C22.0014 6.89905 14.9414 7.12905 13.2814 10.159L13.3214 8.47905Z",
    fill: "#0967C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareLinkedin);
export default __webpack_public_path__ + "static/media/share-linkedin.4f10c783271082918b9aca80450c696c.svg";
export { ForwardRef as ReactComponent };